import React from "react";
import { TaskSourceType } from "src/api/generated/postgres/db/types/tasks/enums/taskSourceType.ts";
import { TaskView } from "src/api/generated/postgres/db/types/tasks/tables/taskView.ts";
import { OpenGenericDialogFunc } from "src/components/common/dialogs/GenericDialogProvider.tsx";
import { OpenLegacyViewFunction } from "src/components/views/legacy/hooks.ts";
import { ProjectActivityApi } from "src/api/generated/erp/project/projectActivity/api/projectActivityApi.ts";
import { SingleReclamationView } from "../../erp/reclamation/SingleReclamationView.tsx";

export interface TaskSourceActions {
	openSource: (params: OpenTaskSourceParams) => Promise<void>;
	taskContextMenu: (task: TaskView) => Promise<React.ReactNode[]>;
}

export interface OpenTaskSourceParams {
	sourceId: number;
	openGenericDialog: OpenGenericDialogFunc;
	openLegacyView: OpenLegacyViewFunction;
}

export const getTaskSourceActions = (sourceType: TaskSourceType): TaskSourceActions => {
	switch (sourceType) {
		case "PROJECT_ACTIVITY":
			return projectActivityTaskSourceActions;

		case "CUSTOMER_ORDER":
			return customerOrderTaskSourceActions;

		case "CUSTOMER_ORDER_OFFER":
			return customerOrderOfferTaskSourceActions;

		case "SAFETY_CONTROL_SURVEY":
			return safetyControlSurveyTaskSourceActions;

		case "PRODUCT_CHANGE_REQUEST":
			return productChangeRequestTaskSourceActions;

		case "RECLAMATION":
			return reclamationTaskSourceActions;

		case "RECLAMATION_V2":
			return reclamationV2TaskSourceActions;

		case "PROCESS_IMPROVEMENT":
			return processImprovementTaskSourceActions;

		case "WORKSPACE":
			return workspaceTaskSourceActions;
	}
};

const projectActivityTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		const activity = await ProjectActivityApi.getSingleActivity({
			activityId: sourceId,
		});
		openLegacyView("49ff4499-499d-4a25-85ee-565af927a3b9", {
			subProjectId: activity.subProjectId,
			_activityIdFilter: activity.activityId,
		});
	},
	taskContextMenu: async () => {
		return [
			// TODO
		];
	},
};

const customerOrderTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		openLegacyView("9e3e45c8-2825-4d57-8c33-eddec1c5b786-2", {
			_customer_order_id_filter: sourceId,
		});
	},
	taskContextMenu: async () => {
		return [];
	},
};

const customerOrderOfferTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		openLegacyView("C1709442020929CA", {
			_customer_order_offer_id_filter: sourceId,
		});
	},
	taskContextMenu: async () => {
		return [];
	},
};

const safetyControlSurveyTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		openLegacyView("8654300BDB2F06B9", {
			safetyControlSurveyIdFilter: sourceId,
		});
	},
	taskContextMenu: async () => {
		return [];
	},
};

const productChangeRequestTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		openLegacyView("55779DD6319D59A4", {
			_product_change_request_id_filter: sourceId,
		});
	},
	taskContextMenu: async () => {
		return [];
	},
};

const reclamationTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		openLegacyView("5d103f17-6dcd-4b42-b9f6-5b379a99ecf6", {
			_reclamation_id_filter: sourceId,
		});
	},
	taskContextMenu: async () => {
		return [];
	},
};

const processImprovementTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		openLegacyView("6d2b012a-7f8e-43b3-8e00-9b57fcfff360", {
			_process_improvement_id_filter: sourceId,
		});
	},
	taskContextMenu: async () => {
		return [];
	},
};

const workspaceTaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openLegacyView }) => {
		openLegacyView("E5EA27DCCC63FBB4", {
			_workspace_id_filter_list: sourceId,
		});
	},
	taskContextMenu: async () => {
		return [];
	},
};

const reclamationV2TaskSourceActions: TaskSourceActions = {
	openSource: async ({ sourceId, openGenericDialog }) => {
		openGenericDialog(() => ({
			title: "Reclamation",
			children: <SingleReclamationView reclamationId={sourceId} />,
		}));
	},
	taskContextMenu: async () => {
		return [];
	},
};
